import React, { Component } from 'react'
import SalesforceUserMapping from 'components/SFDC/containers/UserMapping'
import { salesforceAction } from 'app/modules/rules/models'

import './style.styl'

const MAPPED_SALESFORCE_USERS_URL = '/settings/salesforce/mapping/users'

class SalesforceAction extends Component {

  componentDidMount() {
    this.props.setPageValidity(true)
  }

  onMappingsChange = ({ isValid }) => {
    this.props.setPageValidity(isValid)
    if (isValid) {
      this.props.updateAction({
        ...salesforceAction,
        options: {}
      })
    } 
  }

  render() {
    return (
      <div className="rules-choice rules-url-filter salesforce-user-mapping-rules">
        <header>
          <h1>Add Participants</h1>
          <p>We’ll add the mapped Lead or Account Owner in Salesforce as a participant in the conversation.
            <br/>To map a new Salesforce user to Drift, head to your<a href={MAPPED_SALESFORCE_USERS_URL}> Mapped Salesforce Users.</a>
          </p>
        </header>
        <div className="rules-editor-content">
          <div className="rules-choice-content drift-form salesforce-user-mappings-read-only">
            <SalesforceUserMapping 
              readOnly={true}
              onChange={this.onMappingsChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default SalesforceAction



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/SalesforceAction/index.js